module.exports = __webpack_public_path__ + "img/SheerLove.2cb912f8.png";